"use strict";

var postalCode, warehousesStr, postalCodeElement, 
  checkoutTermsContainer, availabilityElement, calculateBtn,
  freeShippingElement, orderTableElement
postalCodeElement = document.getElementById("postal_code");
checkoutTermsContainer = $("#checkout_terms_container");
availabilityElement = $("#availability");
calculateBtn = $("#calculate_btn");
freeShippingElement = $("#freeShippingAmount");
orderTableElement = $("#order_table");

//Need in correct format to post order
function formatPostalCode(postalCode) {
  var formattedPostalCode;
  formattedPostalCode = postalCode.replace(" ","");
  formattedPostalCode = formattedPostalCode.slice(0,3) + " " + formattedPostalCode.slice(3);
  postalCodeElement.value = formattedPostalCode;
}

function validatePostalCode() {
  postalCode = postalCodeElement.value;
  if (/\w\d\w\s\d\w\d/.test(postalCode)) {
    return true;
  } else {
    postalCodeElement.value="";
    postalCodeElement.placeholder="invalid postal code";
  }
}

function  storePostalCode() {
  postalCode = postalCodeElement.value;
  window.localStorage.setItem("postalCode", postalCode);
}

function loadPostalCode(postalCode) {
  if (postalCode) {
    return postalCodeElement.value=postalCode
  }
}

function enableWarehouseSelection() {
  var warehouseSelectionElement;
  warehouseSelectionElement = document.getElementById("warehouse-selection");
  (postalCodeElement.value.length > 0) ? warehouseSelectionElement.hidden=false : warehouseSelectionElement.hidden=true;
}

function storePreferredWarehouses() {
  var warehouses, checkboxes;
  if (postalCodeElement.value) {
    warehouses=[];
    for (var checkbox of document.getElementsByName("warehouses")) {
      if (checkbox.checked) {
        warehouses.push(checkbox.value);
      }
    }
    window.localStorage.setItem("warehousesStr", warehouses.join(","));
  }
}

function loadPreferredWarehouses(warehousesStr) {
  if (warehousesStr) {
    if (warehousesStr.indexOf("BC") === -1) {
    document.getElementById("BC").checked = false;
    }
    if (warehousesStr.indexOf("AB") === -1) {
    document.getElementById("AB").checked = false;
    }
    if (warehousesStr.indexOf("ON") === -1) {
    document.getElementById("ON").checked = false;
    }
    if (warehousesStr.indexOf("QC") === -1) {
    document.getElementById("QC").checked = false;
    }
    return warehousesStr
  }
}

function toggleCalculateBtn() {
  if (calculateBtn.prop("disabled")) {
    calculateBtn.prop("disabled", false)
    $("#status").hide()
  } else {
    calculateBtn.prop("disabled", true)
    $("#status").show()
  }
}

function getCartDetails(postalCode, warehousesStr, payloadLines, cartItems, totalPrice) {
  return new Promise((resolve, reject) => {
    var data;
    data=JSON.stringify({'postalCode':postalCode, 'warehousesStr':warehousesStr, 'payloadLines':payloadLines, 'cartItems':cartItems, 'totalPrice':totalPrice})
    toggleCalculateBtn()
    $.ajax({
      url: "https://cart-detail.detailbasics.com/",
      type: "POST",
      data: data,
      contentType: "application/json",
      processData: false,
      crossDomain: true,
      success: function(data){
        resolve(data);
      },
      error: function(){
        reject("Error in the request");
        orderTableElement.html("An error occured. Please contact us for more information or proceed to checkout where shipping will be calculated.");
      }
    });
  });
};

function postOrderTable(data) {
  orderTableElement.html(data.order_table_html)
};

calculateBtn.click(function() {
  if (validatePostalCode()) {
    storePostalCode()
    storePreferredWarehouses()
    // Update items 
    $('[name="update"]').click()    
  }
});

function postShipping(data) {
  $("#shipping_by_warehouse").html(data.shipping_by_warehouse_html)
  $("#subtotal").html(data.subtotal)
  if (data.total_price > data.promotional_free_shipping_target) {
    freeShippingElement.html('Congratulations! You qualified for free shipping!')
    if (data.total_price < data.default_free_shipping_target) {
      $("#discountCode").html("Use code <em>" + data.discount_code + "</em> at checkout") //No code needed for orders over default_free_shipping_target
    }
  } else {
    freeShippingElement.html('Purchase <em>$' + data.promotional_free_shipping_target + '+</em> to get free shipping from these warehouses')
  }
};

function showCheckoutTermsElement(data) {
  if (data.has_line_errors) {
    checkoutTermsContainer.show()
  }
};

function postAvailability(data) {
  //hidden element
  availabilityElement.val(JSON.stringify(data.availability))
};

function renderCartDetails(data) {
  if ('message' in data) {
    orderTableElement.html(data['message'])
  } else {
    postOrderTable(data);
    postShipping(data);
    showCheckoutTermsElement(data);
    postAvailability(data);
  }
};

$("#deleteBtn").click(function() {
  var data, lengthOfData;
  data = JSON.parse(availabilityElement.val())
  lengthOfData = data.length
  for (var a=0; a<lengthOfData; a++) {
    document.getElementById(data[a][0]).value = data[a][1]
  }
  checkoutTermsContainer.hide()
})

postalCodeElement.addEventListener("change", function() {formatPostalCode(postalCodeElement.value)}); //Could also use event.target.value
postalCodeElement.addEventListener("keyup", enableWarehouseSelection);
checkoutTermsContainer.hide();

if (localStorage.postalCode) {
  postalCode=loadPostalCode(localStorage.postalCode);
  if (validatePostalCode()) {
    warehousesStr=loadPreferredWarehouses(localStorage.warehousesStr);
    enableWarehouseSelection()
    getCartDetails(postalCode, warehousesStr, payloadLines, cartItems)
      .then(renderCartDetails)
      .then(toggleCalculateBtn)
  } else {
    window.localStorage.removeItem("postalCode")
    postalCodeElement.placeholder="postal code"
  }
}